
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import PostLayout from "@src/layouts/PostLayout";
import { harajukuWosyokuHarajukuWashokuImage } from "@src/constants/images";
import InstaImage from "@src/components/InstaImage";
import { murakamiMasanori } from "@src/constants/authors";
import GoogleMap from "@src/components/GoogleMap";
export const meta = {
  path: "/media/harajuku/wasyoku",
  title: "【厳選和食】原宿・表参道でしか食べられない和食ランチはこの2つ！",
  description: "原宿・表参道エリアでおいしい和食が食べられるお店を2つ厳選してご紹介します！休日は「健康的な和食を食べたい！」という方も多いのではないでしょうか？そんな人のために、栄養価が高く消化が良い和食が食べられるお店をご紹介します！",
  topImg: harajukuWosyokuHarajukuWashokuImage,
  author: murakamiMasanori,
  tags: ["和食", "有名店", "原宿", "おしゃれな内装", "人気店", "まとめ記事", "食べログ高評価"]
};

const layoutProps = {
  meta
};
const MDXLayout = ({ children }) => (
  <PostLayout meta={meta}>{children}</PostLayout>
)
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`原宿・表参道エリアでおいしい和食が食べられるお店を、原宿・表参道それぞれ１店舗ずつご紹介させていただ k ます！`}</p>
    <p>{`「和食」という言葉を聞くと、「割烹やお寿司」のような高級感のある店を想像する方も多いのではないでしょうか。`}</p>
    <p>{`厳選した産地直送の食材にこだわる「ザ テイショク ショップ」、おひつを使った「おひつ膳 田んぼ 」の 2 店で食べられるランチをご紹介します！`}</p>
    <hr></hr>
    <h2>{`おひつ膳 田んぼ 表参道`}</h2>
    <InstaImage postId="xetrBTgNod" mdxType="InstaImage" />
    <h3>{`和食といえばお米！最上のお米を食べられるお店`}</h3>
    <h4>{`週替わりで使用するお米が変わる!?`}</h4>
    <p>{`おひつ膳 田んぼ 表参道は、週替わりでお米が変わるため、来店の度に違うお米を楽しむことができます！`}</p>
    <h4>{`お米を毎日精米`}</h4>
    <p>{`お店でお米を精米しており、精米したての新鮮なお米が食べられることが特徴です！`}</p>
    <h3>{`おひつでご飯を食べる？`}</h3>
    <InstaImage postId="B7IdD74Apiq" mdxType="InstaImage" />
    <p>{`おひつ(木の樽のようなもの)でお米を炊き、おひつに入ったままご飯が食べられることが、おひつ膳 田んぼ の最大の特徴になります。
おひつで作ると、米の水分が乾燥しないため、水分が保たれたまま`}<strong parentName="p">{`もっちりした食感`}</strong>{`を楽しめます！`}</p>
    <h3>{`１回の注文で２種類の食べ方を楽しめる!?`}</h3>
    <p>{`おひつで作られたご飯を、なんと２種類も楽しむことができるそうです！
ここからはその流れをお伝えしますね！`}</p>
    <h4>{`1 回目はお米本来の味を`}</h4>
    <p>{`鮭いくらおひつ膳というランチメニューになります！
おひつに入ったお米の本来の味を堪能してみてください！`}</p>
    <InstaImage postId="B8DjZ3GjIST" include={[0]} exclude={[4]} mdxType="InstaImage" />
    <h4>{`2 回目はお茶漬けに`}</h4>
    <p>{`おひつのお米を小皿に取り出し、上からダシをかけてお茶漬けに！
お米の甘みがダシと合わさって、繊細な味わいになります！`}</p>
    <InstaImage postId="B8DjZ3GjIST" include={[3]} exclude={[4]} mdxType="InstaImage" />
    <h3>{`ランチメニュー(値段付き)`}</h3>
    <p>{`おひつ膳のメニューは 10 種類程度あるので、こちらでは全て紹介が難しいので、今回は代表的な人気の３種類のおひつをご紹介させてください！`}</p>
    <h4>{`鮭といくらのおひつ膳(1,900 円)`}</h4>
    <p>{`こちらが 1 番人気メニューの`}<strong parentName="p">{`鮭といくらのおひつ膳(1,900 円)`}</strong>{`になります！
贅沢な焼鮭と新鮮ないくらにふっくら炊けたご飯。
薬味、寒天、とろろ、味噌汁などがついており、バランスの取れたボリューム感のあるランチメニューになります！`}</p>
    <InstaImage postId="B8p4Q2hj2Rl" mdxType="InstaImage" />
    <h4>{`明太子のおひつ膳(1,580 円)`}</h4>
    <p>{`分厚い明太子が乗ったおひつ膳で、ふっくら炊けた甘いお米と明太子の塩気がマッチする一品。
お値段も鮭といくらのおひつ膳(1,900 円)よりはリーズナブルなので、手が出しやすい一品となっています。`}</p>
    <InstaImage postId="B9mDeZ3gd_7" mdxType="InstaImage" />
    <InstaImage postId="Bxm4EoQF64q" mdxType="InstaImage" />
    <p>{`１度で２種類の味が楽しめる楽しめるおひつご飯は、おひつ膳 田んぼは表参道以外にも数種類ありますので、是非調べてみてください！`}</p>
    <hr></hr>
    <h3>{`アクセス`}</h3>
    <GoogleMap lat={35.6570313} lng={139.6926224} mdxType="GoogleMap" />
    <hr></hr>
    <h2>{`ザ テイショク ショップ 原宿`}</h2>
    <h3>{`原宿の名店「ザ グレイトバーガー」 のオーナーが手がける和食のお店`}</h3>
    <InstaImage postId="B7D49olAsz0" include={[0]} mdxType="InstaImage" />
    <p>{`原宿のハンバーガーを賑わせてるザ グレートバーガーですが、そのオーナーがなんと`}<strong parentName="p">{`和食`}</strong>{`のお店も展開していたんです！
`}<strong parentName="p">{`「日本好きのアメリカ人が営む、風変わりな和食屋」`}</strong>{`というコンセプトを出してい和食のお店が、`}<strong parentName="p">{`ザ テイショク ショップ `}</strong>{`。`}</p>
    <h4>{`昔どこかでみた懐かしい外観`}</h4>
    <p>{`日本文化を思わせる外観なのに、原宿の町に馴染んだお店の外観は、まさに和食を想起させてくれるような雰囲気。誰しもが一度は見たことがあるような狸と招き猫、木目の看板が出迎えてくれます！`}</p>
    <InstaImage postId="B4HJCj3hYmq" mdxType="InstaImage" />
    <InstaImage postId="B7syGhlp2nz" mdxType="InstaImage" />
    <h4>{`アンティークが揃う店内`}</h4>
    <p>{`外国人が日本に対して持っている印象をたくさん揃えたアンティークが置かれています！`}</p>
    <InstaImage postId="B6Vvtwwl_a-" mdxType="InstaImage" />
    <p>{`壁紙はこのような印象的な壁紙で、まさに`}<strong parentName="p">{`和`}</strong>{`を表現した和食のお店の印象`}</p>
    <InstaImage postId="B4HJCj3hYmq" mdxType="InstaImage" />
    <p>{`箸置きにも`}<em parentName="p">{`和`}</em>{`をイメージしたこだわりが！`}</p>
    <InstaImage postId="B2CO20FHBPo" mdxType="InstaImage" />
    <hr></hr>
    <h3>{`羽釜で炊くこだわりのお米`}</h3>
    <p>{`白米で仕入れるのではなく一等枚の玄米を仕入れて、その日に使う分だけを精米するそうです！
おひつ膳 田んぼと近いものがありますよね。`}</p>
    <h4>{`ランチタイムはご飯が食べ放題`}</h4>
    <p>{`ランチタイムはこの羽釜で炊くお米が食べ放題というお得感があります！
和食の美味しい食材と一緒に、おいしいご飯がたくさん食べられるのも人気の一つです。`}</p>
    <h3>{`食材へのこだわり`}</h3>
    <p>{`お米だけでなく、料理全ての食材の質にこだわっています。`}</p>
    <p>{`国産牛の肉を使用したり、しらす老舗の名店「山利」の釜揚げしらす、脂がしっかり乗った銀鮭、こだわりの野菜。北海道産知床鶏の唐揚げなど、どのメニューを頼んでも素材の味を最大限に活かした味を楽しむことができるのが最大の特徴です！`}</p>
    <InstaImage postId="BzMuB_JJLfa" mdxType="InstaImage" />
    <InstaImage postId="Bx8sF_3puvU" mdxType="InstaImage" />
    <InstaImage postId="BwmZhNbHn0m" mdxType="InstaImage" />
    <hr></hr>
    <h3>{`アクセス`}</h3>
    <p>{`原宿と明治神宮駅から徒歩５分程度の距離にあります！
`}<strong parentName="p">{`裏原`}</strong>{`と呼ばれる原宿の若者が多いエリアで、和食が食べられるのは中々ないのではないのではないでしょうか。`}</p>
    <GoogleMap lat={35.6661478} lng={139.7028199} mdxType="GoogleMap" />
    <hr></hr>
    <h3>{`おわりに`}</h3>
    <p>{`いかがでしたでしょうか？
日本発祥の和食だからこそ、普段食べることも少ないとは思います。原宿・表参道エリアにいくときに、少しでも健康的な和食が食べたいと思った時には、この 2 つのお店を選んでみてください！
きっと、素晴らしい体験になるのではないかと思います！`}</p>

    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;